import { render, staticRenderFns } from "./NewsletterSubscription.vue?vue&type=template&id=f55b2d98&scoped=true&"
import script from "./NewsletterSubscription.vue?vue&type=script&lang=js&"
export * from "./NewsletterSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55b2d98",
  null
  
)

export default component.exports